import CriarCustomForm from './CriarCustomForm'
import enhance from './CriarCustomForm.enhancer'

export default enhance(CriarCustomForm)



// WEBPACK FOOTER //
// ./src/routes/sistema/CriarCustomForm/components/CriarCustomForm/index.js